module.exports = __webpack_public_path__ + "img/ChinaLogisticsProperty.a66060f1.jpg";